import { fetchFlask } from '../../utils/fetchFlask';
import { parseNumberPtBrOrThrow } from '../../utils/numberUtils';
import { isBlank } from '../../utils/stringFormat';

export const allReasonsOption = 'all';

export const fetchDistratosMes = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('getDistratosMes', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.distratos;
};

export const parseContractedKwh = (value) => (
    isBlank(value)
        ? 0
        : parseNumberPtBrOrThrow(value, `Contratado inválido recebido para distrato: ${value}`)
);

export const normalizeReason = (value) => {
    const reason = String(value || '').trim();
    return reason || 'Sem motivo informado';
};

export const buildDistratosSummary = (distratos) => {
    const clients = new Set();
    const units = new Set();
    const totalContracted = distratos.reduce((total, distrato) => total + parseContractedKwh(distrato.contratado), 0);

    distratos.forEach((distrato) => {
        if (distrato.cliente) {
            clients.add(distrato.cliente);
        }

        if (distrato.unidade) {
            units.add(distrato.unidade);
        }
    });

    return {
        totalClients: clients.size,
        totalUnits: units.size,
        totalContracted
    };
};

export const buildReasonOptions = (distratos) => {
    const reasons = Array.from(new Set(distratos.map((distrato) => normalizeReason(distrato.motivo))))
        .sort((left, right) => left.localeCompare(right, 'pt-BR'));

    return [
        { value: allReasonsOption, label: 'Todos os motivos' },
        ...reasons.map((reason) => ({ value: reason, label: reason }))
    ];
};

export const filterDistratosByReason = (distratos, selectedReasons) => {
    const reasons = Array.isArray(selectedReasons) ? selectedReasons : [selectedReasons];
    if (reasons.length === 0 || reasons.includes(allReasonsOption)) return distratos;

    const selectedReasonSet = new Set(reasons);
    return distratos.filter((distrato) => selectedReasonSet.has(normalizeReason(distrato.motivo)));
};

export const buildReasonChartRows = (distratos) => {
    const reasonMap = new Map();

    distratos.forEach((distrato) => {
        const reason = normalizeReason(distrato.motivo);
        const currentReason = reasonMap.get(reason) || {
            reason,
            clients: new Set(),
            units: new Set(),
            contracted: 0
        };

        if (distrato.cliente) {
            currentReason.clients.add(distrato.cliente);
        }

        if (distrato.unidade) {
            currentReason.units.add(distrato.unidade);
        }

        currentReason.contracted += parseContractedKwh(distrato.contratado);
        reasonMap.set(reason, currentReason);
    });

    return Array.from(reasonMap.values())
        .map((item) => ({
            reason: item.reason,
            clients: item.clients.size,
            units: item.units.size,
            contracted: item.contracted
        }))
        .sort((left, right) => {
            if (right.units !== left.units) return right.units - left.units;
            return right.contracted - left.contracted;
        });
};

export const buildDistratoRows = (distratos) => distratos.map((distrato, index) => ({
    id: `${distrato.unidade || 'unidade'}-${distrato.data_distrato || 'data'}-${index}`,
    dataDistrato: distrato.data_distrato,
    motivo: normalizeReason(distrato.motivo),
    unidade: distrato.unidade,
    contratado: parseContractedKwh(distrato.contratado),
    cliente: distrato.cliente,
    inicio: distrato.inicio
}));
